export default __webpack_public_path__ + "static/media/preferences.95dc55ed.jpg";